/* 5571be40f4d999e4ceda03559797e9e0a03f644f
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QrCodeQueryVariables = Types.Exact<{
  reservationNo: Types.Scalars['String'];
  phoneNo: Types.Scalars['String'];
}>;


export type QrCodeQuery = { __typename?: 'Query', qrCode: { __typename?: 'QrCode', qrInfo: string } };


export const QrCodeDocument = gql`
    query QrCode($reservationNo: String!, $phoneNo: String!) {
  qrCode(reservationNo: $reservationNo, phoneNo: $phoneNo) {
    qrInfo
  }
}
    `;

/**
 * __useQrCodeQuery__
 *
 * To run a query within a React component, call `useQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQrCodeQuery({
 *   variables: {
 *      reservationNo: // value for 'reservationNo'
 *      phoneNo: // value for 'phoneNo'
 *   },
 * });
 */
export function useQrCodeQuery(baseOptions: Apollo.QueryHookOptions<QrCodeQuery, QrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QrCodeQuery, QrCodeQueryVariables>(QrCodeDocument, options);
      }
export function useQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QrCodeQuery, QrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QrCodeQuery, QrCodeQueryVariables>(QrCodeDocument, options);
        }
export type QrCodeQueryHookResult = ReturnType<typeof useQrCodeQuery>;
export type QrCodeLazyQueryHookResult = ReturnType<typeof useQrCodeLazyQuery>;
export type QrCodeQueryResult = Apollo.QueryResult<QrCodeQuery, QrCodeQueryVariables>;